<ng-select
  class="autocomplete-person"
  [typeToSearchText]="'Scrivi 2 o pià caratteri (ragione sociale)' | translate"
  [notFoundText]="'Nessun risultato trovato' | translate"
  [ngModel]="value$ | async"
  [disabled]="isDisabled$ | async"
  [bindValue]="bindValue"
  [bindLabel]="bindLabel"
  [items]="people$ | async"
  [dropdownPosition]="'bottom'"
  [placeholder]="placeholder | translate"
  [typeahead]="peopleInput$"
  (focus)="onFocusHandler()"
  (change)="changeValueHandler($event)">
</ng-select>
